import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";
import { useMyLinks } from "@/features/identity/hooks/useMyLinks";
import { IdentityPreview } from "@/features/identity/components/IdentityPreview";
import { CompletionPanel } from "@/features/dashboard/components/CompletionPanel";
import { StatusBanner } from "@/components/StatusBanner";
import { NfcBanner, QuickLinks } from "@/features/dashboard/components/QuickLinks";
import { ROUTES } from "@/constants/routes";

export default function DashboardOverview() {
  const { profile } = useProfile();
  const links = useMyLinks();
  const firstName = profile.full_name?.split(/\s+/)[0];

  return (
    <div className="mw-rise space-y-10">
      <section className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mw-eyebrow">Dashboard</p>
          <h1 data-testid="dashboard-welcome-heading" className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl lg:text-6xl">
            Welcome{firstName ? `, ${firstName}` : ""}.
          </h1>
        </div>
        <Link to={ROUTES.profileEditor} data-testid="dashboard-edit-identity-button" className="mw-btn mw-btn-primary self-start sm:self-auto">
          <Pencil className="h-4 w-4" /> Edit professional identity
        </Link>
      </section>
      {links.status === "error" && (
        <div className="flex flex-wrap items-center gap-3">
          <StatusBanner testId="dashboard-links-error">{links.error}</StatusBanner>
          <button type="button" onClick={links.reload} data-testid="dashboard-links-retry" className="mw-btn mw-btn-ghost">Retry</button>
        </div>
      )}
      <NfcBanner />
      <QuickLinks />
      <div className="grid gap-6 xl:grid-cols-[1fr_300px]">
        <IdentityPreview profile={profile} links={links.links} />
        <CompletionPanel profile={profile} links={links} />
      </div>
    </div>
  );
}
